import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LoggerService } from '../logger/logger.service';
import { HttpErrorService } from './http-error.service';

@Injectable()
export class RuntimeErrorHandlerService extends ErrorHandler {
    constructor(
        private messageService: MessageService,
        private loggerService: LoggerService,
        private readonly errorService: HttpErrorService,
        private readonly ngZone: NgZone,
    ) {
        super();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public override handleError(error: any): void {
        // HTTP errors are handled completely
        if (error instanceof HttpErrorResponse) {
            this.errorService.processResponseError(error);
            return super.handleError(error);
        }

        // or HTTP errors wrapped in promises
        if (error.rejection && error.rejection instanceof HttpErrorResponse) {
            this.errorService.processResponseError(error.rejection);
            return super.handleError(error);
        }

        this.ngZone.run(() => {
            this.messageService.clear('error');
            this.messageService.add({
                key: 'error',
                sticky: true,
                severity: 'error',
                data: {
                    timestamp: new Date(),
                    url: window.location.href,
                    message: error.message,
                    stacktrace: error.stack || JSON.stringify(error),
                },
            });
        });

        this.loggerService.error(error.message, error.stack || JSON.stringify(error));
        return super.handleError(error);
    }
}
